function Info() {
  return (
    <h1>Info</h1>
  )
}

export default Info
